import { useEffect, useRef } from 'react';
import './ads.scss';

const BannerThree = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//raggedteach.com/bKX.VnsmdsGHlO0iYwWdce/WebmB9/uCZLUYlRkMPWTkYc1/MxzBQMwPMejGExtzNvjwUzzaNXDvAQyUMYgW';
    script.async = true;
    script.referrerPolicy = 'no-referrer-when-downgrade';

    if (containerRef.current) {
      containerRef.current.appendChild(script);
    }
  }, []);

  return (
    <div className="bannerOne" ref={containerRef}></div>
  );
};

export default BannerThree;
